/** H5 顶栏下频道导航（Polymarket 式：图标 + 文案横滑） */
export const H5_CHANNEL_NAV_ITEMS = [
  {
    key: 'recommended',
    to: '/explore',
    labelKey: 'nav.channelRecommended',
    icon: 'forYou',
    match: (path) => path === '/explore' || path.startsWith('/explore/'),
  },
  {
    key: 'sport',
    to: '/sport',
    labelKey: 'nav.sport',
    icon: 'sport',
    match: (path) => path.startsWith('/sport'),
  },
  {
    key: 'crypto',
    to: '/crypto',
    labelKey: 'nav.crypto',
    icon: 'crypto',
    match: (path) => path.startsWith('/crypto'),
  },
  {
    key: 'leagues',
    to: '/leagues',
    labelKey: 'nav.leagues',
    icon: 'leagues',
    match: (path) => path.startsWith('/leagues'),
  },
];
